module.exports = __webpack_public_path__ + "img/icon-share.39b5e7de.svg";